<script>
import axios from "@/axios";
import AdminHeader from "./AdminHeader.vue";
import Swal from "sweetalert2";
export default {
  components: { AdminHeader },
  data: () => ({
    dialog: false,
    edit: false,
    loading: true,
    framework: {
      id: "",
      name: "",
      color: "",
      icon: "",
    },
    frameworks: [],

    headers: [
      { title: "Name", key: "name", align: "start" },
      { title: "Color", key: "color", align: "start" },
      { title: "Icon", key: "icon", align: "start" },
      { title: "Actions", key: "actions", align: "end", sortable: false },
    ],
  }),
  created() {
    this.fetchFramework();
  },
  methods: {
    deleteItem(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          try {
            axios.delete(`/framework/${id}`).then((res) => {
              Swal.fire({
                title: "Deleted!",
                text: "Your file has been deleted.",
                icon: "success",
              });

              this.fetchFramework();
            });
          } catch (error) {
            console.error("An error ocurred:", error);
          }
        }
      });
    },
    
    async editFramework() {
      let payload = this.framework;
      let id = this.framework.id;
      try {
        await axios.put(`/framework/${id}`, payload, {});
        this.fetchFramework();
        this.resetForm();
        this.dialog = false;
      } catch (error) {
        console.error("An error occured while adding", error);
      }
    },
    editItem(framework) {
      this.edit = true;
      this.framework.id = framework.id;
      this.framework.name = framework.name;
      this.framework.color = framework.color;
      this.framework.icon = framework.icon;
      this.dialog = true;
    },
    resetForm() {
      this.framework.name = "";
      this.framework.color = "";
      this.framework.icon = "";

    },
    addData() {
      this.edit = false;
      this.resetForm();
      this.dialog = true;
    },
    async addFramework() {

    //   let payload = new FormData();
    //   payload.append('experience_id', this.$route.params.id)
    //   payload.append('description', this.framework.description)
      try {
        await axios.post("/framework", {
            project_id: this.$route.params.id,
            name: this.framework.name,
            color: this.framework.color,
            icon: this.framework.icon,
        });
        this.fetchFramework();
        this.resetForm();
      } catch (error) {
        console.error("An error occured while adding", error);
      }
    },

    async fetchFramework() {
      try {

        const response = await axios.get(`/filtered_frameworks/${this.$route.params.id}`);
        this.frameworks = response.data.frameworks;

        //this.experienceId = this.$route.params.id

       // console.log(this.experienceId)
      } catch (error) {
        console.error("An error occured while adding", error);
      }
    },
  },
};
</script>
<template>
  <AdminHeader />

  <v-card class="mx-auto" max-width="100%">
    <v-card-title>
      <v-container>
        <v-row>
          <v-col cols="12" sm="12" md="6">
            <v-btn to="/adminprojects" class="ma-2" variant="text" icon="mdi-arrow-left-circle" color="blue-lighten-2" ></v-btn>
            <v-chip size="large" color="green" label>{{
              $route.params.title
            }}</v-chip>
            <v-btn
              @click="addData()"
              class="ma-2"
              variant="text"
              icon="mdi-plus-box"
              color="blue-lighten-2"
            ></v-btn>
          </v-col>
          <v-col cols="12" sm="12" md="6">
            <v-text-field
              v-model="name"
              placeholder="Placeholder"
              variant="underlined"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </v-card-title>

    <v-card-text>
      <v-data-table :items="frameworks" :headers="headers">

        <template v-slot:item.actions="{ item }">
          <v-icon size="small" class="me-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon size="small" @click="deleteItem(item.id)">
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
    </v-card-text>
    <v-card-actions> </v-card-actions>
  </v-card>

  <v-row justify="center">
    <v-dialog v-model="dialog" persistent width="1024">
      <v-form @submit.prevent="edit ? editFramework() : addFramework()">
        <v-card>
          <v-card-title>
            <span class="text-h5">{{ edit ? "Edit Data" : "Add Data" }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="framework.name"
                    label="Name"
                    variant="underlined"
                    prepend-icon="mdi-file-document-outline"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="framework.color"
                    label="Color"
                    variant="underlined"
                    prepend-icon="mdi-file-document-outline"
                    hint="text-blue-500"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="framework.icon"
                    label="Icon"
                    variant="underlined"
                    prepend-icon="mdi-file-document-outline"
                    hint="fa-solid fa-code"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue-darken-1" variant="text" @click="dialog = false">
              Close
            </v-btn>
            <v-btn color="blue-darken-1" variant="text" type="submit">
              {{ edit ? "Update" : "Add" }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-row>
</template>
